import { translate } from "app/filters/i18nFilter";
import CardHeader from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardHeader/CardHeader";
import { CardErrorBoundary } from "app/pages/sales-intelligence/pages/company-analysis/components/shared/CardErrorBoundary/CardErrorBoundary";
import CompanyData from "app/pages/sales-intelligence/pages/company-analysis/containers/overview/CompanyData/CompanyData";

const CompanyDataWithErrorBoundary = () => (
    <CardErrorBoundary
        dataAutomation="company-data"
        header={<CardHeader title={translate("si.company-analysis.company-data.card.header")} />}
    >
        <CompanyData />
    </CardErrorBoundary>
);

export default CompanyDataWithErrorBoundary;
